module.exports = require("core-js-pure/stable/object/get-own-property-symbols");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols.js
// module id = 258
// module chunks = 0 1